import { SearchIcon, Textfield } from "@gromia/components/input/Textfield";
import { Redirect } from "@gromia/components/Link";
import * as s from "@gromia/components/theme/t.module.css";
import { useForm } from "@gromia/utils/useForm";
import { pipe } from "fp-ts/lib/function";
import * as O from "fp-ts/lib/Option";
import * as TE from "fp-ts/lib/TaskEither";
import * as t from "io-ts";
import React from "react";

type Props = {
  initialValue?: string;
  onChange: (q: O.Option<string>) => React.ReactNode;
};

export function navigateToSearch(q: O.Option<string>) {
  return pipe(
    q,
    O.map(x => <Redirect to={`/blog/ricerca?q=${encodeURIComponent(x)}`} />),
    O.toNullable,
  );
}

export function SearchField(props: Props) {
  const form = useForm("searchForm", t.type({ q: t.string }), {
    onSubmit: ({ q }) => {
      const el = props.onChange(
        pipe(
          q,
          O.fromNullable,
          O.filter(x => x.length > 0),
        ),
      );
      return TE.right(el);
    },
    initialValues: { q: props.initialValue },
  });

  return (
    <form className={s.w100} autoComplete="off" {...form.formProps()}>
      {O.toNullable(form.submitValue)}
      <Textfield
        type="text"
        name="q"
        label={<span />}
        placeholder="Cosa stai cercando? es. contratti"
        iconRight={
          <span className={s.textPrimary}>
            <SearchIcon />
          </span>
        }
        noFormGroup
        {...form.props("q")}
      />
      <input type="submit" style={{ position: "absolute", left: "-9999px" }} />
    </form>
  );
}
